<div *ngIf="formData">
<mat-card appearance="outlined"
          [ngClass]="{'mat-card-height-auto': externalPage === 'incoming',
                      'mat-card-height-full': externalPage !== 'incoming'}"
          class="coll-themed-class  full-width">
    <div id="toolupload-component">
        <form [formGroup]="formData" class="custom-col-class col-sm-6">
            <mat-card-title>{{ 'ImageUpload' | translate }}</mat-card-title>
            <!--accordion -->
            <div *ngIf="externalPage === 'incoming'" class="example-action-buttons">
                <button mat-button class="action-button" (click)="accordion.openAll()">{{'se-ui-selector-web_expand_all' | translate}}</button>
                <button mat-button class="action-button" (click)="accordion.closeAll()">{{'se-ui-selector-web_collapse_all' | translate}}</button>
            </div>

                <mat-accordion class="example-headers-align" #accordion="matAccordion" [multi]="externalPage === 'incoming'">
                    <mat-expansion-panel formGroupName="patientData" [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="flex-basis-revert">
                                {{'TitlePatientData' | translate}}
                            </mat-panel-title>
                            <mat-panel-description>
                                <div [style.visibility]="showFormValidation('patientData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-edit"></div>
                                <div [style.visibility]="showFormError('patientData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-error"></div>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <!-- dati paziente -->
                        <mat-card-content class="coll-themed-class border-1-solid margin-bottom-7-important flex-input-container">
                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'issuer')}">{{'Issuer' | translate}}</mat-label>
                                    <input matInput id="issuer" formControlName="issuer">
                                </mat-form-field>
                            </div>
                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'patientId')}">{{'PatientIdentifier' | translate}}</mat-label>
                                    <input matInput id="patientId" formControlName="patientId" [placeholder]="'PatientIdentifier' | translate">
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'surname')}">{{'LastName' | translate}}</mat-label>
                                    <input matInput id="surname" formControlName="surname" [placeholder]="'LastName' | translate">
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'name')}">{{'FirstName' | translate}}</mat-label>
                                    <input matInput id="name" formControlName="name" [placeholder]="'FirstName' | translate">
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'sex')}">{{'Sex' | translate}}</mat-label>
                                    <input matInput id="sex" formControlName="sex" [placeholder]="'Sex' | translate">
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'taxCode')}">{{'TaxCode' | translate}}</mat-label>
                                    <input matInput id="taxCode" formControlName="taxCode" [placeholder]="'TaxCode' | translate" pattern="^([a-zA-Z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[a-zA-Z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[a-zA-Z]{1})$|([0-9]{11})$">
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'birthDate')}">{{'BirthDate' | translate}}</mat-label>
                                    <input matInput formControlName="birthDate" [matDatepicker]="picker">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker typeof="date"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </mat-card-content>
                    </mat-expansion-panel>

                    <mat-expansion-panel formGroupName="orderData" [expanded]="externalPage === 'incoming'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="flex-basis-revert">
                                {{'OrderData' | translate}}
                            </mat-panel-title>
                            <mat-panel-description>
                                <div [style.visibility]="showFormValidation('orderData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-edit"></div>
                                <div [style.visibility]="showFormError('orderData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-error"></div>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <!-- dati ordine -->
                        <mat-card-content class="coll-themed-class border-1-solid margin-bottom-7-important flex-input-container">
                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderDescription')}">{{'OrderDescription' | translate}}</mat-label>
                                    <input matInput id="orderDescription" formControlName="orderDescription" [placeholder]="'OrderDescription' | translate">
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderDate')}">{{'OrderDate' | translate}}</mat-label>
                                    <input matInput formControlName="orderDate" [matDatepicker]="picker2">
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2 typeof="date"></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderProvenance')}">{{'OrderProvenance' | translate}}</mat-label>
                                    <input matInput id="orderProvenance" formControlName="orderProvenance" [placeholder]="'OrderProvenance' | translate">
                                </mat-form-field>
                            </div>

                            <div *ngIf="externalPage !== 'incoming' && !uploadInfo.OrderBusinessUnit">
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderBusinessUnit')}">{{'OrderBusinessUnit' | translate}}</mat-label>
                                    <div>
                                        <mat-select id="orderBusinessUnit" formControlName="orderBusinessUnit">
                                            <mat-option *ngFor="let option of options" [value]="option">{{option.description}}</mat-option>
                                        </mat-select>
                                    </div>
                                </mat-form-field>
                            </div>

                            <div *ngIf="externalPage !== 'incoming' && uploadInfo.OrderBusinessUnit">
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label  [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderBusinessUnit')}">{{'OrderBusinessUnit' | translate}}</mat-label>
                                    <div>
                                        <input matInput id="description" formControlName="orderBusinessUnit" [placeholder]="'OrderBusinessUnit' | translate">
                                    </div>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderNumber')}">{{'OrderNumber' | translate}}</mat-label>
                                    <input matInput id="orderNumber" formControlName="orderNumber" [placeholder]="'OrderNumber' | translate">
                                </mat-form-field>
                            </div>
                        </mat-card-content>
                    </mat-expansion-panel>

                    <mat-expansion-panel formGroupName="physicianData">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="flex-basis-revert">
                                {{'OperatorAndPhysicianData' | translate}}
                            </mat-panel-title>
                            <mat-panel-description>
                                <div [style.visibility]="showFormValidation('physicianData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-edit"></div>
                                <div [style.visibility]="showFormError('physicianData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-error"></div>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <!-- dati Physician -->
                        <mat-card-content class="coll-themed-class border-1-solid margin-bottom-7-important flex-input-container">
                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('physicianData', 'referringPhysicianName')}">{{'ReferringPhysicianFirstName' | translate}}</mat-label>
                                    <input matInput id="referringPhysicianName" formControlName="referringPhysicianName" [placeholder]="'ReferringPhysicianFirstName' | translate">
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field appearance="outline" class="se-form-field card-input-field" [hideRequiredMarker]="true">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('physicianData', 'referringPhysicianSurname')}">{{'ReferringPhysicianSurname' | translate}}</mat-label>
                                    <input matInput id="referringPhysicianSurname" formControlName="referringPhysicianSurname" [placeholder]="'ReferringPhysicianSurname' | translate">
                                </mat-form-field>
                            </div>
                        </mat-card-content>
                    </mat-expansion-panel>
                </mat-accordion>
            </form>

            <div class="col-sm-6 import-file-container">
                <import-file class="custom-col-class"
                             [acceptedTypeFile]="loadedData.acceptedFormats"
                             (fileData)="onFileUploaded($event)">
                </import-file>
            </div>
        </div>

        <file-upload class="col-sm-12" [ngClass]="{'align-flex-end': externalPage !== 'incoming'}"
                     [filesList]="filesList"
                     [formData]="formData"
                     [loadedData]="loadedData"
                     [externalPage]="externalPage">
        </file-upload>

    </mat-card>

</div>

